import { createHttpService } from "../ApiService";
import { IAuthParams } from "./auth.interfaces";
import { authoriseUserRequest, refreshTokenRequest } from "./authRequests";

export const useAuthService = () => {
  const httpAPI = createHttpService();

  return {
    authoriseUser: (requestObj: IAuthParams) =>
      authoriseUserRequest(httpAPI, requestObj),
    refreshToken: () => refreshTokenRequest(httpAPI),
  };
};
